import { CompanyNameWithIcon } from '../CompanyNameWithIcon';
import { NarrativeTabs } from '../NarrativeTabs';

import { NarrativeForm } from '../../utils/schema';
import { NarrativeCompany } from '../../hooks/useNarrativeById';

type Props = {
  authorDisplayName: string;
  company: NarrativeCompany;
  onChange: (values: Partial<NarrativeForm>) => void;
  readOnly: boolean;
  values: NarrativeForm;
  onReset: () => void;
};

export const NarrativeSidebar = ({
  authorDisplayName,
  company,
  onChange,
  readOnly,
  values,
  onReset,
}: Props) => {
  return (
    <div className="grid lg:rounded-x2 h-min grid-rows-[repeat(3,max-content)] bg-p-grey-100">
      <div className="grid justify-start p-x2 pb-x1">
        <CompanyNameWithIcon
          name={company.name}
          tickerSymbol={company.tickerSymbol}
          websiteUrl={company.info?.url}
          canonicalURL={company.canonicalURL}
        />
      </div>
      <NarrativeTabs
        company={company}
        onChange={onChange}
        values={values}
        readOnly={readOnly}
        authorDisplayName={authorDisplayName}
        onReset={onReset}
      />
    </div>
  );
};
